import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards'),
  },
  {
    path: '/user/my-account',
    name: 'user',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/user/my-account'),
  },
  {
    path: '/campaign/order-confirmation/:businessTypeSlug/:campaignNameSlug',
    redirect: '/campaigns/order-confirmation/:businessTypeSlug/:campaignNameSlug',
  },
  {
    path: '/campaigns/order-confirmation/:businessTypeSlug/:campaignNameSlug',
    name: 'campaignsOrderConfirmation',
    component: () => import('./views/campaigns/order-confirmation'),
  },
  {
    path: '/campaigns/live-creative/:businessTypeSlug/:campaignNameSlug',
    name: 'campaignsLiveCreative',
    component: () => import('./views/campaigns/live-creative'),
  },
  {
    path: '/campaign/:businessTypeSlug/:campaignNameSlug',
    name: 'campaignsLandingPage',
    component: () => import('./views/campaigns/landing-page'),
  },
  {
    path: '/proposal/:id/summary/:token',
    redirect: '/proposal/:id/:token',
  },
  {
    path: '/proposal/:id/:token',
    name: 'proposalProposal',
    component: () => import('./views/proposals/proposal'),
  },
  {
    path: '/advertisers',
    name: 'advertisers',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/advertisers'),
  },

  {
    path: '/advertisers/create',
    name: 'advertisersCreate',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/advertisers/create'),
    children: [
      {
        path: 'business',
        meta: {
          cardTitle: 'Business Details',
          cardText: 'Onboard and profile the advertiser and their campaign needs.The information collected during this process is utilised to optimise creative and deliver better campaign results.'
        }
      },
       {
         path: 'market',
         meta: {
           cardTitle: 'Marketing Details',
           cardText: 'In this step profile the category of business operation, the key marketing objectives, business service area and audience the advertiser is looking to engage with.'
         }
       },
       {
         path: 'profile',
         meta: {
           cardTitle: 'Profile Description',
           cardText: 'In this final step, profile and describe the advertiser by adding and uploading specific assets to support the creative and asset creation to cover all campaign channels.'
         }
       }
    ]
  },
  {
    path: '/advertisers/:id',
    name: 'advertisersView',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/advertisers/view')
  },
  {
    path: '/advertisers/:id/activity-log',
    name: 'advertisersViewActivityLog',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/advertisers/activity-log'),
  },
  {
    path: '/advertisers/:id/edit',
    name: 'advertisersEdit',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/advertisers/edit'),
    children: [
      {
        path: 'business',
        meta: {
          cardTitle: 'Business Details',
          cardText: 'Onboard and profile the advertiser and their campaign needs.The information collected during this process is utilised to optimise creative and deliver better campaign results.'
        }
      },
       {
         path: 'market',
         meta: {
           cardTitle: 'Marketing Details',
           cardText: 'In this step profile the category of business operation, the key marketing objectives, business service area and audience the advertiser is looking to engage with.'
         }
       },
       {
         path: 'profile',
         meta: {
           cardTitle: 'Profile Description',
           cardText: 'In this final step, profile and describe the advertiser by adding and uploading specific assets to support the creative and asset creation to cover all campaign channels.'
         }
       }
    ]
  },
  {
    path: '/campaigns',
    name: 'campaigns',
    meta: {
      authRequired: true
    },
    component: () => import('./views/campaigns'),
  },
  {
    path: '/campaigns/create',
    name: 'campaignsCreate',
    meta: {
      authRequired: true
    },
    component: () => import('./views/campaigns/create'),
    children: [
      {
        path: 'name',
        meta: {
          cardTitle: 'Campaign Name',
          cardText: 'Onboard a new campaign for an advertiser. Select an Advertiser Profile and match it with a masthead and campaign objective. Remember you can come back to edit later.'
        }
      },
      {
        path: 'assets',
        meta: {
          cardTitle: 'Campaign Assets',
          cardText: 'Continue building the Campaign by adding Descriptions to be used throughout the campaign. Default content which can be dited or replaced is pulled from their profile. Choose an ad format that highlights their best images.'
        }
      },
      {
        path: 'branding',
        meta: {
          cardTitle: 'Campaign Branding',
          cardText: 'Continue by adding images and colour choices along with profile contact information. It’s important to have the legal right to use the images and that all contact information is correct. Remember you can come back to edit later.'
        }
      },
      {
        path: 'configuration',
        meta: {
          cardTitle: 'Campaign Configuration',
          cardText: 'Finalise the campaign set-up to ensure traffic, call to actions, channels and launch dates are set up accordingly. You can also preview creative examples and save as a draft to edit or launch later.'
        }
      }
    ]
  },
  {
    path: '/campaigns/:id/payment',
    name: 'campaignsPayment',
    meta: {
      authRequired: true
    },
    component: () => import('./views/campaigns/payment'),
  },
  {
    path: '/campaigns/:id',
    name: 'campaignsView',
    meta: {
      authRequired: true
    },
    component: () => import('./views/campaigns/dashboard'),
  },
  {
    path: '/campaigns/:id/edit',
    name: 'campaignsEdit',
    meta: {
      authRequired: true
    },
    component: () => import('./views/campaigns/edit'),
    children: [
      {
        path: 'name',
        meta: {
          cardTitle: 'Campaign Name',
          cardText: 'Onboard a new campaign for an advertiser. Select an Advertiser Profile and match it with a masthead and campaign objective. Remember you can come back to edit later.'
        }
      },
      {
        path: 'assets',
        meta: {
          cardTitle: 'Campaign Assets',
          cardText: 'Continue building the Campaign by adding Descriptions to be used throughout the campaign. Default content which can be dited or replaced is pulled from their profile. Choose an ad format that highlights their best images.'
        }
      },
      {
        path: 'branding',
        meta: {
          cardTitle: 'Campaign Branding',
          cardText: 'Continue by adding images and colour choices along with profile contact information. It’s important to have the legal right to use the images and that all contact information is correct. Remember you can come back to edit later.'
        }
      },
      {
        path: 'configuration',
        meta: {
          cardTitle: 'Campaign Configuration',
          cardText: 'Finalise the campaign set-up to ensure traffic, call to actions, channels and launch dates are set up accordingly. You can also preview creative examples and save as a draft to edit or launch later.'
        }
      }
    ]
  },
  {
    path: '/orders',
    name: 'orders',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/orders'),
  },
  {
    path: '/packages',
    name: 'packages',
    meta: {
      authRequired: true,
      disallowedRoles: [
        "ROLE_ADMIN",
        "ROLE_SALES_MANAGER",
        "ROLE_SALES_REPRESENTATIVE"
      ]
    },
    component: () => import('./views/packages'),
  },
  {
    path: '/packages/create',
    name: 'packagesCreate',
    meta: {
      authRequired: true,
      disallowedRoles: [
        "ROLE_ADMIN",
        "ROLE_SALES_DIRECTOR",
        "ROLE_SALES_MANAGER",
        "ROLE_SALES_REPRESENTATIVE"
      ]
    },
    component: () => import('./views/packages/create'),
  },
  {
    path: '/packages/:id/edit',
    name: 'packagesEdit',
    meta: {
      authRequired: true,
      disallowedRoles: [
        "ROLE_ADMIN",
        "ROLE_SALES_MANAGER",
        "ROLE_SALES_REPRESENTATIVE"
      ]
    },
    component: () => import('./views/packages/edit'),
  },
  {
    path: '/proposals',
    name: 'proposals',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/proposals'),
  },
  {
    path: '/proposals/create',
    name: 'proposalsCreate',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/proposals/create'),
  },
  {
    path: '/proposals/:id/edit',
    name: 'proposalsEdit',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/proposals/edit'),
  },
  {
    path: '/reports',
    name: 'reports',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/reports'),
  },
  {
    path: '/users',
    name: 'users',
    meta: {
      authRequired: true,
      disallowedRoles: [
        "ROLE_SALES_REPRESENTATIVE"
      ]
    },
    component: () => import('./views/users'),
  },
  {
    path: '/users/create',
    name: 'usersCreate',
    meta: {
      authRequired: true,
      disallowedRoles: [
        "ROLE_SALES_REPRESENTATIVE"
      ]
    },
    component: () => import('./views/users/create'),
  },
  {
    path: '/users/:id/edit',
    name: 'usersEdit',
    meta: {
      authRequired: true,
      disallowedRoles: [
        "ROLE_SALES_REPRESENTATIVE"
      ]
    },
    component: () => import('./views/users/edit'),
  },
  {
    path: '/mastheads',
    name: 'mastheads',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/mastheads'),
  },
  {
    path: '/mastheads/create',
    name: 'mastheadsCreate',
    meta: {
      authRequired: true,
      disallowedRoles: [
        "ROLE_SALES_DIRECTOR",
        "ROLE_SALES_MANAGER",
        "ROLE_SALES_REPRESENTATIVE"
      ]
    },
    component: () => import('./views/mastheads/create'),
  },
  {
    path: '/mastheads/:id/edit',
    name: 'mastheadsEdit',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/mastheads/edit'),
  },
  {
    path: '/history',
    name: 'history',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/history'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut');

        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/oauth/callback',
    name: 'authCallback',
    meta: {
      beforeResolve() {
        store.dispatch("auth/oneLoginCallback", window.location.search);
      }
    }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('./layouts/404'),
  },
  {
    path: '*',
    redirect: '/404',
  }
]
